export default class ModalDialogWrangler {
  constructor(dialogElements) {
    // console.log('setting up event delegation for', dialogElements)

    // Because there may be many dialogs on any given page,
    // this uses a single event handler to listen for any kind
    // of dialog-related click event to keep things snappy.
    document.addEventListener('click', event => {
      if (event.target.hasAttribute('data-modal-trigger')) {
        this.handleModalOpen(event)
        return
      }

      if (event.target.hasAttribute('data-modal-close')) {
        const currentDialog = event.target.closest('dialog')
        currentDialog.close()
        return
      }

      this.handleBackdropClick(event)
    })
  }


  handleModalOpen(event) {
    const modalId = event.target.getAttribute('data-modal-trigger')
    const dialog = document.querySelector(`[data-modal=${modalId}]`)

    dialog.showModal()
  }

  handleBackdropClick(event) {
    const currentDialog = document.querySelector('dialog[open]')
    if (currentDialog && event.target === currentDialog) {
      // This seems counterintuitive, but the <dialog> element's default layout
      // fills the whole viewport. So if this event's target is the dialog element
      // and not its contents, that means the click landed on the backdrop.
      currentDialog.close()
    }
  }


}

